const initialState = {
  workOrderType: 'all',
  workOrderStatus: 'all',
  startDate: '',
  endDate: '',
  searchData: {},
  searchOption: '',
  searchText: '',
  pageNumber: 1,
  totalSize: 0,
  isPushedSearchButton: false,
}
const resetState = {
  workOrderType: 'all',
  workOrderStatus: 'all',
  startDate: '',
  endDate: '',
  searchData: {},
  searchOption: '',
  searchText: '',
  pageNumber: 1,
  totalSize: 0,
  isPushedSearchButton: false,
};

const failedProductionOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SETFAILEDPRODUCTIONORDERWORKORDERTYPE':
      return {
        ...state,
        workOrderType: action.payload,
      };
    case 'SETFAILEDPRODUCTIONORDERWORKORDERSTATUS':
      return {
        ...state,
        workOrderStatus: action.payload,
      };
    case 'SETFAILEDPRODUCTIONORDERSTARTDATE':
      return {
        ...state,
        startDate: action.payload,
      };
    case 'SETFAILEDPRODUCTIONORDERENDDATE':
      return {
        ...state,
        endDate: action.payload,
      };
    case 'SETFAILEDPRODUCTIONORDERSEARCHDATA':
      return {
        ...state,
        searchData: action.payload,
      };
    case 'SETFAILEDPRODUCTIONORDERSEARCHOPTION':
      return {
        ...state,
        searchOption: action.payload,
      };
    case 'SETFAILEDPRODUCTIONORDERSEARCHTEXT':
      return {
        ...state,
        searchText: action.payload,
      };
    case 'SETFAILEDPRODUCTIONORDERPAGENUMBER':
      return {
        ...state,
        pageNumber: action.payload,
      };
    case 'SETFAILEDPRODUCTIONORDERTOTALSIZE':
      return {
        ...state,
        totalSize: action.payload,
      };
    case 'SETFAILEDPRODUCTIONORDERISPUSHEDSEARCHBUTTON':
      return {
        ...state,
        isPushedSearchButton: action.payload,
      };
    case 'SETFAILEDPRODUCTIONORDERRESET':
      return {
        ...state,
        ...resetState,
      };
    default:
      return state;
  };
};

export default failedProductionOrderReducer;